module.exports = __webpack_public_path__ + "img/logo.3c5c02a0.png";